import { Instant, LocalDate, LocalTime, DateTimeFormatter, ZoneId, Locale } from './datetime';
import { SITE_IS_AUTO } from '../utility/constants';
export const formatDollars = (x) => {
    return new Intl.NumberFormat('en-US', {
        'style': 'currency',
        'currency': 'USD',
        'minimumFractionDigits': 2,
        'maximumFractionDigits': 2,
    }).format(Math.round(x * 100) / 100);
};
/**
 *
 * @param x
 * @param digits
 * @returns default en-US formatting?
 */
export const formatNumber = (x) => {
    return new Intl.NumberFormat('en-US', {}).format(x);
};
/**
 *
 * @param x
 * @param digits
 * @returns `x` formatted to AT MOST `digits` digits, defaulting to 2
 */
export const formatNumberD = (x, digits = 2) => {
    return new Intl.NumberFormat('en-US', {
        'maximumFractionDigits': digits,
    }).format(x);
};
/**
 *
 * @param x
 * @param digits
 * @returns `x` formatted to EXACTLY `digits` digits, defaulting to 2
 */
export const formatNumberDE = (x, digits = 2) => {
    return new Intl.NumberFormat('en-US', {
        'minimumFractionDigits': digits,
        'maximumFractionDigits': digits,
    }).format(x);
};
export const formatDate = (x) => {
    const pattern = DateTimeFormatter.ofPattern('M/d/yyyy').withLocale(Locale.US);
    return (x === null
        ? ''
        : x instanceof LocalDate
            ? x.format(pattern)
            : x instanceof Instant
                ? x.atZone(ZoneId.SYSTEM).format(pattern)
                : (console.error('formatDate - fallthrough', x), '#ERROR#'));
};
export const formatDateLong = (x) => {
    const pattern = DateTimeFormatter.ofPattern('EEEE MMMM d, yyyy').withLocale(Locale.US);
    return (x === null
        ? ''
        : x instanceof LocalDate
            ? x.format(pattern)
            : x instanceof Instant
                ? x.atZone(ZoneId.SYSTEM).format(pattern)
                : (console.error('formatDate - fallthrough', x), '#ERROR#'));
};
export const formatTime = (x) => {
    const pattern = DateTimeFormatter.ofPattern('h:mm a').withLocale(Locale.US);
    return (x === null
        ? ''
        : x instanceof LocalTime
            ? x.format(pattern)
            : x instanceof Instant
                ? x.atZone(ZoneId.SYSTEM).format(pattern)
                : (console.error('formatTime - fallthrough', x), '#ERROR#'));
};
export const formatDateShort = (x) => {
    const pattern = DateTimeFormatter.ofPattern('MMM d, yyyy').withLocale(Locale.US);
    return (x === null
        ? ''
        : x instanceof Instant
            ? x.atZone(ZoneId.SYSTEM).format(pattern)
            : (console.error('formatDateShort - fallthrough', x), '#ERROR#'));
};
// Message-timeline style: relative for today (`3:45 PM`), `Yesterday`,
// weekday name for this week, calendar date for older. Used in CRM
// conversation list + message thread bubbles.
export const formatMessageTime = (x, now) => {
    if (x === null) {
        return '';
    }
    const zone = ZoneId.SYSTEM;
    const then = x.atZone(zone);
    const today = now.atZone(zone).toLocalDate();
    const thenDate = then.toLocalDate();
    const daysBetween = today.toEpochDay() - thenDate.toEpochDay();
    if (daysBetween === 0) {
        return then.format(DateTimeFormatter.ofPattern('h:mm a').withLocale(Locale.US));
    }
    if (daysBetween === 1) {
        return 'Yesterday';
    }
    if (daysBetween < 7) {
        return then.format(DateTimeFormatter.ofPattern('EEE').withLocale(Locale.US));
    }
    return then.format(DateTimeFormatter.ofPattern('MMM d').withLocale(Locale.US));
};
// Relative age display used in the SA admin CRM health view.
// `2m ago`, `3h ago`, `4d ago`.
export const formatRelativeAge = (x, now) => {
    if (x === null) {
        return '';
    }
    const diffMs = now.toEpochMilli() - x.toEpochMilli();
    const min = Math.floor(Math.abs(diffMs) / 60000);
    const hr = Math.floor(Math.abs(diffMs) / 3600000);
    const day = Math.floor(Math.abs(diffMs) / 86400000);
    const suffix = diffMs >= 0 ? 'ago' : 'from now';
    if (min < 1) {
        return 'just now';
    }
    if (min < 60) {
        return `${min}m ${suffix}`;
    }
    if (hr < 24) {
        return `${hr}h ${suffix}`;
    }
    return `${day}d ${suffix}`;
};
export const formatDateTime = (x) => {
    const pattern = DateTimeFormatter.ofPattern('M/d/yyyy h:mm a').withLocale(Locale.US);
    return (x === null
        ? ''
        : x instanceof LocalDate
            ? x.format(pattern)
            : x instanceof Instant
                ? x.atZone(ZoneId.SYSTEM).format(pattern)
                : (console.error('formatDateTime - fallthrough', x), '#ERROR#'));
};
export const formatDatetimeLong = (x) => {
    const pattern = DateTimeFormatter.ofPattern('EEEE MMMM d, yyyy h:mm a').withLocale(Locale.US);
    return (x === null
        ? ''
        : x instanceof LocalDate
            ? x.format(pattern)
            : x instanceof Instant
                ? x.atZone(ZoneId.SYSTEM).format(pattern)
                : (console.error('formatDate - fallthrough', x), '#ERROR#'));
};
export const formatRole = (x) => {
    return x.split('-').map((x) => x.charAt(0).toUpperCase() + x.slice(1)).join(' ');
};
export const formatInvoiceNumber = (x) => {
    if (!!x) {
        switch (x === null || x === void 0 ? void 0 : x.classification) {
            case 'estimate':
            case 'estimate-approved':
                return `EST-${x.number}`;
            case 'order':
                return `${SITE_IS_AUTO ? 'RO' : 'ORD'}-${x.number}`;
            case 'invoice':
            case 'invoice-semipaid':
            case 'invoice-paid':
                return `INV-${x.number}`;
        }
    }
    else {
        return '&mdash;';
    }
    // return x ? `${!!x.closed ? 'INV' : !!x.approved ? (SITE_IS_AUTO ? 'RO' : 'ORD') : 'EST'}-${x.number}` : '&mdash;'
};
export default {
    formatDollars,
    formatNumber,
    formatNumberD,
    formatDate,
    formatDateLong,
    formatTime,
    formatDatetimeLong,
    formatRole,
    formatInvoiceNumber,
};
